module.exports = __webpack_public_path__ + "img/bg.53984933.jpg";